<template>
    <div class="tuesday-action-data border-1 text-black fw-bold fs-6 text-center rounded-1">
        AKCIJA UTORKOM
    </div>
</template>

<style lang="sass" scoped>
    .tuesday-action-data
        padding-top: 2px
        background-color: var(--ct-gray-300)
        border: 1px solid var(--ct-gray-300)
</style>
